export const EDGE_ACTIVITIES_COLUMNS = {
  TIMESTAMP: {
    Header: 'Date/Time (UTC)',
    id: 'timestamp',
    accessor: 'timestamp',
  },
  USER_NAME: {
    Header: 'Source / User',
    id: 'user_name',
    accessor: 'user_name',
  },
  ORIGIN: {
    Header: 'Where',
    id: 'origin',
    accessor: 'origin',
  },
  FIELD: {
    Header: 'Field / Action Name',
    id: 'field',
    accessor: 'field',
  },
  OLD_VALUE: {
    Header: 'Old Value',
    id: 'old_value',
    accessor: 'old_value',
  },
  NEW_VALUE: {
    Header: 'New Value / Action Result',
    id: 'new_value',
    accessor: 'new_value',
  },
};

export const EDGE_ACTIVITIES_EXPORT_HEADERS = Object.values(EDGE_ACTIVITIES_COLUMNS).map(({ Header }) => Header);

export const EDGE_ACTIVITIES_TABLE_ID = 'edgeActivitiesList';
